import React, { useRef } from 'react';
import { Box, Text } from '@chakra-ui/react';

const IntentionCard = ({ intention, onIntentionChange, theme }) => {
  const textareaRef = useRef(null);

  return (
    <Box
      borderRadius="xl"
      p={4}
      style={{
        background: theme.cardBg,
        border: `1px solid ${theme.cardBorder}`,
        backdropFilter: 'blur(12px)',
      }}
    >
      <Text
        fontSize="11px"
        fontWeight="600"
        letterSpacing="0.14em"
        textTransform="uppercase"
        mb={3}
        style={{ color: theme.textMuted }}
      >
        Today&apos;s focus
      </Text>

      <Box
        borderRadius="lg"
        p={3}
        onClick={() => textareaRef.current?.focus()}
        style={{
          background: theme.inputBg,
          border: `1px solid ${theme.cardBorder}`,
          cursor: 'text',
          minHeight: '64px',
        }}
      >
        <textarea
          ref={textareaRef}
          className="fl-input"
          value={intention}
          onChange={(e) => onIntentionChange(e.target.value)}
          placeholder="What are you working on?"
          maxLength={120}
          rows={2}
          style={{
            color: intention ? theme.textPrimary : theme.textDim,
            fontSize: '13px',
            lineHeight: '1.55',
            display: 'block',
          }}
        />
      </Box>

      {intention && (
        <Text
          fontSize="10px"
          textAlign="right"
          mt={1.5}
          style={{ color: theme.textDim }}
        >
          {intention.length}/120
        </Text>
      )}
    </Box>
  );
};

export default IntentionCard;
